import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-evento-sessao-dialog',
  templateUrl: 'dialog.component.html',
})
export class EventoSessaoDialogComponent implements OnInit {

  loading: boolean;
  sessions: string;
  session: string;

  constructor(
    public dialogRef: MatDialogRef<EventoSessaoDialogComponent>,
    public dataService: DataService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getSessions();
  }

  getSessions() {
    this.dataService.eventoSessao()
      .subscribe((response: any) => {
        this.loading = false;
        this.sessions = response;
      });
  }

  selectSession(session: any) {
    this.dialogRef.close(session);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
